import { useEffect, useState } from "react";

/**
 * Returns a boolean that flips `true` `delay` ms after `isError` becomes
 * `true`, and resets to `false` whenever `isError` flips back to `false`.
 *
 * Drives the in-place error-recovery transition: each trade form's CTA
 * button shows e.g. `"Buy Failed"` immediately on error, then transitions
 * (fade-shrink-blur) to `"Return to Buy"` once this hook flips true. The
 * delay gives the user time to read the failure wording before the CTA
 * pivots to a recovery affordance.
 *
 * @param isError  True while the form is in its error phase.
 * @param delay    Milliseconds to wait before flipping ready. Default 2000ms.
 */
export function useErrorReturnReady(isError: boolean, delay = 2000): boolean {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (!isError) {
            setReady(false);
            return;
        }
        const t = window.setTimeout(() => setReady(true), delay);
        return (): void => window.clearTimeout(t);
    }, [isError, delay]);

    return ready;
}
